export const MODE = {
  primary: 'primary',
  secondary: 'secondary',
  secondaryLite: 'secondaryLite',
  secondaryTransparent: 'secondaryTransparent',
  link: 'link',
  borderedOnly: 'borderedOnly',
  secondaryBordered: 'secondaryBordered',
} as const

export const SIZE = {
  big: 'big',
  small: 'small',
  medium: 'medium',
  compact: 'compact',
  extrasmall: 'extrasmall',
} as const

export const ICON_PLACEMENT = {
  beforeText: 'beforeText',
  afterText: 'afterText',
} as const
